import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M5.25 15.75q-.618 0-1.06-.441a1.44 1.44 0 0 1-.44-1.059V4.5a.73.73 0 0 1-.535-.216A.72.72 0 0 1 3 3.75q0-.318.216-.535A.72.72 0 0 1 3.75 3h3q0-.318.216-.535A.72.72 0 0 1 7.5 2.25h3q.319 0 .535.216A.72.72 0 0 1 11.25 3h3q.319 0 .535.216A.72.72 0 0 1 15 3.75q0 .318-.216.535a.72.72 0 0 1-.534.215v9.75q0 .619-.441 1.06-.441.44-1.059.44zm7.5-11.25h-7.5v9.75h7.5zm-6 8.25h1.5V6h-1.5zm3 0h1.5V6h-1.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }